import firebase from "firebase";

let config = {
    apiKey: "AIzaSyALTRz1nQc1KKDj5VDlJBo1cCqxmTCMVC0",
    authDomain: "jolly-battle.firebaseapp.com",
    databaseURL: "https://jolly-battle.firebaseio.com",
    projectId: "jolly-battle",
    storageBucket: "jolly-battle.appspot.com",
    messagingSenderId: "308069215520",
    appId: "1:308069215520:web:4b8f9c4c9e59c29630fb45",
    measurementId: "G-69LXTHBLWQ"
};

firebase.initializeApp(config);

export default firebase;

// firebase.auth().onAuthStateChanged((user) => {
//     if (!user) {
//         window.app.$emit("APP_LOGOUT");
//     }
// });
